import React, { useState, useEffect } from "react";
import { useParams, Link } from 'react-router-dom';
import Navigation from "../Navigation";
import ArticlesImg from "./../../images/articles.jpg";
import configVars from "../../config";
import { getWithExpiry, setWithExpiry } from '../../common';
import {Helmet} from "react-helmet";
import HorizontalNav from "../Dashboard/HorizontalNav";

const Articles = () => {

    const { categoryslug, childslug } = useParams();
	const [childCategories, setChildCategories] = useState([]);
	const [categoryName, setCategoryName] = useState('');
	const [categoryPosts, setCategoryPosts] = useState([]);
	const [visibleNumber, setVisibleNumber] = useState(9);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {

		const savedCategoryData = getWithExpiry(`sy_${categoryslug}_category_data`);

        if ( savedCategoryData ) {
            setChildCategories(savedCategoryData.child_categories);
			setCategoryName(savedCategoryData.category_name);

			if ( childslug ) {
				let childPosts = savedCategoryData.category_posts.reduce( (filtered, category_post) => {
					if (category_post.post_categories.includes(childslug)) {
						filtered.push( category_post );
					}
					return filtered;
				}, []);

				setCategoryPosts(childPosts);
			} else {
				setCategoryPosts(savedCategoryData.category_posts);
			}
		
        } else {

			setIsLoading( true );

            (async () => {

                const response = await fetch(
                    `${configVars.apiUrl}sustainchange/v1/getpostsbycategoryslug/?slug=${categoryslug}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                    }
                );
    
                const categoryResponse = await response.json();
    
                if ( categoryResponse ) {

                    if ( categoryResponse.success === true ) {
                        setWithExpiry( `sy_${categoryslug}_category_data`, categoryResponse.data );
                        setChildCategories( categoryResponse.data.child_categories );
						setCategoryName(categoryResponse.data.category_name);
						
						if ( childslug ) {
							let childPosts = categoryResponse.data.category_posts.reduce( (filtered, category_post) => {
								if (category_post.post_categories.includes(childslug)) {
									filtered.push( category_post );
								}
								return filtered;
							}, []);

							setCategoryPosts(childPosts);
						} else {
							setCategoryPosts(categoryResponse.data.category_posts);
						}
                    }

					setIsLoading(false);
                    
                }
    
            })()

        }

	}, [categoryslug, childslug]);
  
    return (
      <div className="main-wrapper">
        <Helmet>
          <title>{categoryName} - KUNSKAP & INSPIRATION</title>
          <meta name="description" content="" />
        </Helmet>
        <Navigation />

        <div className="page-content-wrap">
          <HorizontalNav title="KUNSKAP & INSPIRATION" />

          <div className="pt-5 pt-lg-0 page-content-inner">
            <div
              className="course-img-wrap d-flex overflow-hidden position-relative"
              style={{ maxHeight: "300px" }}
            >
              <img
                src={ArticlesImg}
                alt={categoryslug}
                className="w-100"
                style={{ objectFit: "cover" }}
              />
              <div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column dark-overlay">
                <div className="flex-grow-1 d-flex align-items-center">
                  <h2 className="text-white display-1 text-center text-shadow">
                    {categoryName.replaceAll("&amp;", "&")}
                  </h2>
                </div>
              </div>
            </div>

            <div className="row g-0">
              <div className="col-12 px-4">
                <div
                  className="articles-wrap mx-auto pb-6"
                  style={{ maxWidth: "1200px" }}
                >
                  {isLoading && (
                    <div className="d-flex justify-content-center mt-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}

                  {childCategories && !isLoading && (
                    <div className="categories-wrap mt-5 text-center">
                      <Link
                        to={`/kunskap-inspiration/${categoryslug}/`}
                        className={`btn ${
                          childslug
                            ? "btn-outline-primary"
                            : "btn-primary text-white"
                        } rounded-pill mx-1 mt-2`}
                      >
                        Alla
                      </Link>

                      {childCategories.map((childCategory, index) => {
                        return (
                          <Link
                            to={`/kunskap-inspiration/${categoryslug}/${childCategory.slug}`}
                            className={`btn ${
                              childslug && childslug === childCategory.slug
                                ? "btn-primary text-white"
                                : "btn-outline-primary"
                            } rounded-pill mx-1 mt-2`}
                            key={index}
                          >
                            {childCategory.name.replaceAll("&amp;", "&")}
                          </Link>
                        );
                      })}
                    </div>
                  )}

                  {categoryPosts && categoryPosts.length > 0 && (
                    <div className="category-posts-wrap mt-5">
                      <div className="row">
                        {categoryPosts.map((categoryPost, index) => {
                          return (
                            <div
                              className={`col-12 col-md-6 col-lg-4 mb-4 ${
                                visibleNumber > index ? "" : "d-none"
                              }`}
                              key={index}
                            >
                              <div className="card w-100 h-100 shadow">
                                <div
                                  className="overflow-hidden position-relative"
                                  style={{ height: "230px" }}
                                >
                                  <Link
                                    to={`/kunskap-inspiration/${categoryslug}/p/${categoryPost.post_id}/${childslug ? `?cat=${childslug}` : ''}`}
                                    className="text-decoration-none h-100 d-flex"
                                  >
                                    <img
                                      src={categoryPost.post_thumbnail}
                                      className="card-img-top"
                                      style={{ objectFit: "cover" }}
                                      alt={categoryPost.post_title}
                                    />
                                  </Link>
                                </div>
                                <div className="card-body">
                                  <Link
                                    to={`/kunskap-inspiration/${categoryslug}/p/${categoryPost.post_id}/${childslug ? `?cat=${childslug}` : ''}`}
                                    className="text-downriver text-decoration-none"
                                  >
                                    <h3 className="card-title">
                                      {categoryPost.post_title.replaceAll(
                                        "&amp;",
                                        "&"
                                      )}
                                    </h3>
                                  </Link>
                                  <p className="card-text border-top pt-2">
                                    {categoryPost.post_excerpt.replaceAll(
                                      "&hellip;",
                                      "..."
                                    )}
                                  </p>
                                  <div className="text-end">
                                    <Link
                                      to={`/kunskap-inspiration/${categoryslug}/p/${categoryPost.post_id}/${childslug ? `?cat=${childslug}` : ''}`}
                                      className="text-secondary"
                                    >
                                      <span className="pe-2">Läs mer</span>
                                      <i
                                        className="fa fa-angle-double-right"
                                        aria-hidden="true"
                                      ></i>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <div className="view-more-btn text-center mt-5">
                        <button
                          className={`btn btn-primary text-white btn-lg px-5 rounded-pill ${
                            visibleNumber > 9 ? "d-none" : ""
                          }`}
                          onClick={() => setVisibleNumber(100)}
                        >
                          Visa alla
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Articles;
